import type { FigureTemplatePreset } from '@/store/figure-composition';

export const FIGURE_TEMPLATE_PRESETS: FigureTemplatePreset[] = [
  {
    id: '1x2',
    name: '1×2 (Vertical)',
    description: 'Two panels stacked vertically',
    initialPanels: [
      { x: 0, y: 0, w: 12, h: 6, label: '(a)' },
      { x: 0, y: 6, w: 12, h: 6, label: '(b)' },
    ],
    maxPanels: 2,
  },
  {
    id: '2x1',
    name: '2×1 (Horizontal)',
    description: 'Two panels side by side',
    initialPanels: [
      { x: 0, y: 0, w: 6, h: 12, label: '(a)' },
      { x: 6, y: 0, w: 6, h: 12, label: '(b)' },
    ],
    maxPanels: 2,
  },
  {
    id: '2x2',
    name: '2×2 Grid',
    description: 'Four panels in a grid',
    initialPanels: [
      { x: 0, y: 0, w: 6, h: 6, label: '(a)' },
      { x: 6, y: 0, w: 6, h: 6, label: '(b)' },
      { x: 0, y: 6, w: 6, h: 6, label: '(c)' },
      { x: 6, y: 6, w: 6, h: 6, label: '(d)' },
    ],
    maxPanels: 4,
    suggestedLegendPanelIndex: 1,
  },
  {
    id: '3x1',
    name: '3×1 (Horizontal)',
    description: 'Three panels side by side',
    initialPanels: [
      { x: 0, y: 0, w: 4, h: 12, label: '(a)' },
      { x: 4, y: 0, w: 4, h: 12, label: '(b)' },
      { x: 8, y: 0, w: 4, h: 12, label: '(c)' },
    ],
    maxPanels: 3,
  },
  {
    id: '1plus3',
    name: '1 + 3 (Large + Small)',
    description: 'One large panel with three small panels on the side',
    initialPanels: [
      { x: 0, y: 0, w: 7, h: 12, label: '(a)' },
      { x: 7, y: 0, w: 5, h: 4, label: '(b)' },
      { x: 7, y: 4, w: 5, h: 4, label: '(c)' },
      { x: 7, y: 8, w: 5, h: 4, label: '(d)' },
    ],
    maxPanels: 4,
    suggestedLegendPanelIndex: 1,
  },
  {
    id: 'custom',
    name: 'Custom',
    description: 'Start from an empty canvas',
    initialPanels: [],
    maxPanels: 6,
  },
];










